import { render } from "./campaignDetails.vue?vue&type=template&id=79028d86&scoped=true"
import script from "./campaignDetails.vue?vue&type=script&lang=js"
export * from "./campaignDetails.vue?vue&type=script&lang=js"

import "./campaignDetails.vue?vue&type=style&index=0&id=79028d86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79028d86"]])

export default __exports__